import http from "./../services/httpService";


export async function getConversations() {
    const resp = await http.get(`/conversations/`)
    return resp.data
}

export async function getConversation(id) {
    const resp = await http.get(`/conversations/${id}/`)
    return resp.data
}

export async function postConversation(data) {
    const resp = await http.post('/conversations/', data)
    return resp.data
}

export async function patchConversation(data) {
    const resp = await http.patch(`/conversations/${data.id}/`, data)
    return resp.data
}

export async function deleteConversation(id) {
    const resp = await http.delete(`/conversations/${id}/`)
    return resp.data
}

export async function postMessage(conversationId, data) {
    const resp = await http.post(`/conversations/${conversationId}/add_message/`, data)
    return resp.data
}

export async function postMessageToAsana(messageId) {
    const resp = await http.post(`/core/post_message_to_asana/${messageId}/`)
    return resp.data
}